import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Login from '@/pages/Login'
import Register from '@/pages/register'
import Home from '@/pages/home'
import Usercenter from '@/pages/userCenter'
import VipCenter from '@/pages/vipCenter'
import Access from '@/pages/access'
import TaxList from '@/pages/taxesList'
import NoTax from '@/pages/notaxes'
import UpdateDrr from '@/pages/update'
import TaxState from  '@/pages/taxState'
import Taxdetails from  '@/pages/taxDetails'
import TaxCount from  '@/pages/taxCount'
import CountState from  '@/pages/countState'
import NoCountData from  '@/pages/noCountData'
import ChargeAdd from  '@/pages/chargeAdd'
import Sign from  '@/pages/signature'
import Deduction from  '@/pages/Deduction'
import Usestate from  '@/pages/useState'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'Register',
      component: Register,
      meta: {
        title: '谷町君'
      }
    },
    {
      path: '/useState',
      name: 'Usestate',
      component: Usestate,
      meta: {
        title: '用户协议'
      }
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        title: '房主端首页'
      }
    },
    {
      path: '/taxList',
      name: 'taxList',
      component: TaxList,
      meta: {
        title: '纳税申告'
      }
    },
    {
      path: '/deduction',
      name: 'deduction',
      component: Deduction,
      meta: {
        title: '补充控除'
      }
    },
    {
      path: '/taxcount',
      name: 'taxcount',
      component: TaxCount,
      meta: {
        title: '税务计算'
      }
    },
    {
      path: '/sign',
      name: 'signature',
      component: Sign,
      meta: {
        title: '签名页'
      }
    },
    {
      path: '/noCountData',
      name: 'noCount',
      component: NoCountData,
      meta: {
        title: '税务计算'
      }
    },
    {
      path: '/countState',
      name: 'countState',
      component: CountState,
      meta: {
        title: '税务计算说明'
      }
    },
    {
      path: '/taxDetails',
      name: 'taxDetails',
      component: Taxdetails,
      meta: {
        title: '纳税明细'
      }
    },
    {
      path: '/notaxes',
      name: 'notaxes',
      component: NoTax,
      meta: {
        title: '纳税记录'
      }
    },
    {
      path: '/taxState',
      name: 'taxState',
      component: TaxState,
      meta: {
        title: '纳税声明'
      }
    },
    {
      path: '/user',
      name: 'user',
      component: Usercenter,
      meta: {
        title: '用户中心'
      }
    },
    {
      path: '/access',
      name: 'access',
      component: Access,
      meta: {
        title: '谷町君房主端'
      }
    },
    {
      path: '/chargeAdd',
      name: 'chargeAdd',
      component: ChargeAdd,
      meta: {
        title: '地址管理'
      }
    },
    {
      path: '/updateDrr',
      name: 'update',
      component: UpdateDrr,
      meta: {
        title: '地址更新'
      }
    },
    {
      path: '/vip',
      name: 'VipCenter',
      component: VipCenter,
      meta: {
        title: '会员中心'
      }
    },
  ]
})
router.beforeEach((to, from, next) => {
  var ua = navigator.userAgent.toLowerCase();
  if(ua.match(/MicroMessenger/i)=="micromessenger") {
    if(wx.miniProgram.getEnv){
      next();
    }else{
    if (to.path == '/') {
      var sess = localStorage.getItem('loginData');
      if (sess) {
        next({
          path: '/home'
        })
      } else {
        next();
      }
    } else if(to.path == '/useState'){
      next();
    }else{
      let user = localStorage.getItem('loginData');
      if (!user) {
        next({
          path: '/'
        })
      } else {
        next()
      }
    }
    if (to.meta.title) {
      document.title = to.meta.title
    }else{
      document.title = "谷町君房主端"
    }
    }
  }else{
    console.log(wx);
    if (to.path == '/') {
      var sess = localStorage.getItem('loginData');
      if (sess) {
        next({
          path: '/home'
        })
      } else {
        next();
      }
    } else if(to.path == '/useState'){
      next();
    }else{
      let user = localStorage.getItem('loginData');
      if (!user) {
        next({
          path: '/'
        })
      } else {
        next()
      }
    }
    if (to.meta.title) {
      document.title = to.meta.title
    }else{
      document.title = "谷町君房主端"
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js